var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmpty = function SvgEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 187,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 93.5,
    r: 93.5,
    fill: "#2F80ED",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_26883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 187,
    height: 187
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 93.5,
    r: 93.5,
    fill: "#2F80ED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_26883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8787 116.379L3.38305 99.883C1.81812 98.3181 -0.844694 98.9285 -1.57176 101.019L-26.7549 173.42C-27.3907 175.248 -26.1551 177.191 -24.2301 177.39L116.324 191.93C116.769 191.976 117.219 191.922 117.64 191.772L186.534 167.201C187.716 166.78 188.511 165.668 188.526 164.413L189.921 54.2182C189.953 51.7069 187.069 50.2705 185.084 51.8087L136.59 89.3811C135.395 90.3064 133.699 90.1992 132.631 89.1309L113.121 69.6213C111.95 68.4497 110.05 68.4497 108.879 69.6213L73.6213 104.879C72.4497 106.05 70.5503 106.05 69.3787 104.879L54.6213 90.1213C53.4497 88.9497 51.5503 88.9497 50.3787 90.1213L24.1213 116.379C22.9497 117.55 21.0503 117.55 19.8787 116.379Z",
    fill: "url(#paint0_linear_25_26883)",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_26883",
    x1: 95,
    y1: 48,
    x2: 95,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F80ED",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty.67f16a93d7b679b7296bbc354b209559.svg";